import axios from "../util/axios";

const getUserGuidePreference = () => {
  return axios.get("/user-guide-preference/");
};

const updateUserGuidePreference = (enabled) => {
  return axios.post("/user-guide-preference/", { enabled });
};

const UserPreferencesServices = {
  getUserGuidePreference,
  updateUserGuidePreference,
};

export default UserPreferencesServices;
